import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_FAIL,
  GET_SPECIAL_DATES,
  ADD_SPECIAL_DATES,
  UPDATE_SPECIAL_DATES,
  DELETE_SPECIAL_DATES,
  GET_EXPORT_SPECIAL_DATES,
  GET_EXPORT_SPECIAL_DATES_SUCCESS,
  GET_EXPORTED_SPECIAL_DATES_FAIL,
  RESET_EXPORT_DATA,
  CLEAR_MESSAGE
} from "./actionTypes";

export const specialDatesApiSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const specialDatesApiFail = (actionType, error) => ({
  type: API_RESPONSE_FAIL,
  payload: { actionType, error },
});

export const getSpecialDates = (filter) => ({
  type: GET_SPECIAL_DATES,
  payload: filter
});

export const addNewSpecialDate = data => ({
  type: ADD_SPECIAL_DATES,
  payload: data,
});

export const updateNewSpecialDate = (specialDateId, data) => ({
  type: UPDATE_SPECIAL_DATES,
  payload: { specialDateId, data },
});

export const deleteNewSpecialDate = specialDateId => ({
  type: DELETE_SPECIAL_DATES,
  payload: specialDateId,
});

export const getExportSpecialDate = payload => ({
  type: GET_EXPORT_SPECIAL_DATES,
  payload,
});

export const getExportSpecialDateSuccess = SessionTicket => ({
  type: GET_EXPORT_SPECIAL_DATES_SUCCESS,
  payload: SessionTicket,
});

export const getExportSpecialDateFail = error => ({
  type: GET_EXPORTED_SPECIAL_DATES_FAIL,
  payload: error,
});

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
});

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})


